/**
 * @deprecated This type is deprecated and should not be used in new code.
 * Use SurveysFeatureProperties from application-types instead.
 */
export type SurveysFeatureProperties = {
  _version: undefined | 1;
  type: string;
};

/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use SurveyTypeEnum from application-types instead.
 */
export enum SurveyTypeEnum {
  TenantAdminSatisfaction = 'tenantAdminSatisfaction',
}
